import React, { useState } from 'react';

const Twentieththeme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Graphite */
            --bg-dark: #111827;
            --bg-light: #f3f4f6;
            --text-dark: #1f2937;
            --text-light: #f9fafb;
            --primary: #374151;
            --border: #e5e7eb;
        }
        
        body { font-family: 'Roboto', sans-serif; color: var(--text-dark); background: var(--bg-light); margin: 0; }
        .container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
        
        .navbar { background: white; border-bottom: 1px solid var(--border); padding: 20px 0; }
        .nav-flex { display: flex; justify-content: space-between; align-items: center; }
        .brand { font-weight: 900; letter-spacing: -1px; font-size: 1.5rem; text-transform: uppercase; }
        
        .hero { background: var(--bg-dark); color: white; padding: 120px 0; }
        .hero h1 { font-size: 4rem; margin: 0 0 20px; font-weight: 900; }
        .hero p { font-size: 1.5rem; color: #9ca3af; max-width: 600px; margin: 0 0 40px; }
        
        .btn { background: white; color: black; border: none; padding: 15px 30px; font-weight: 700; cursor: pointer; text-transform: uppercase; letter-spacing: 1px; }
        .btn:hover { background: #d1d5db; }
        .btn-outline { background: transparent; border: 2px solid white; color: white; }
        .btn-outline:hover { background: white; color: black; }
        .btn-dark { background: var(--bg-dark); color: white; border: none; padding: 12px 25px; }
        .btn-dark:hover { background: black; }
        
        .section-header { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 60px; padding-bottom: 20px; border-bottom: 2px solid #000; }
        .section-header h2 { font-size: 3rem; margin: 0; line-height: 1; }
        
        .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 1px; background: #e5e7eb; border: 1px solid #e5e7eb; }
        .cell { background: white; padding: 40px; transition: 0.2s; }
        .cell:hover { background: #f9fafb; }
        
        .product-card { background: white; border: 1px solid var(--border); transition: 0.3s; }
        .product-card:hover { box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1); border-color: transparent; }
        
        .footer { background: white; border-top: 1px solid var(--border); padding: 80px 0; margin-top: 100px; }
            `}</style>
             <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap" rel="stylesheet" />

            <nav className="navbar">
                <div className="container nav-flex">
                    <div className="brand">{get_data.service_name}</div>
                    <div style={{display: 'flex', gap: '30px', fontWeight: 600, fontSize: '0.9rem'}}>
                        <a href="#">HOME</a>
                        <a href="#about">ABOUT</a>
                        <a href="#services">SERVICES</a>
                        <a href="#products">STORE</a>
                    </div>
                </div>
            </nav>

            <header className="hero">
                <div className="container">
                    <h1>SIMPLIFIED<br/>EXCELLENCE.</h1>
                    <p>We provide structural solutions for modern problems. No clutter, just results.</p>
                    <div style={{display: 'flex', gap: '20px'}}>
                        <a href="#services" className="btn">Our Services</a>
                        <a href="#contact" className="btn btn-outline">Contact</a>
                    </div>
                </div>
            </header>
            
            <div style={{padding: '100px 0'}} id="services">
                <div className="container">
                    <div className="section-header">
                        <h2>SERVICES</h2>
                        <span>01 / 03</span>
                    </div>
                    <div className="grid">
                        {get_data.categories && get_data.categories.map((item, index) => (
                            <div className="cell" key={index}>
                                <div style={{fontSize: '2rem', marginBottom: '20px', color: '#111'}}>
                                    {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '40px', height: '40px'}} alt=""/> : <span>■</span>}
                                </div>
                                <h3 style={{fontSize: '1.5rem', marginBottom: '15px'}}>{item.name}</h3>
                                <p style={{color: '#6b7280', fontSize: '0.95rem'}}>{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div style={{padding: '0 0 100px'}} id="products">
                <div className="container">
                     <div className="section-header">
                        <h2>PRODUCTS</h2>
                        <span>02 / 03</span>
                    </div>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '30px'}}>
                         {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="product-card" key={index}>
                                <div style={{height: '250px', background: '#e5e7eb'}}>
                                     <img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} style={{width: '100%', height: '100%', objectFit: 'cover'}} alt=""/>
                                </div>
                                <div style={{padding: '20px'}}>
                                    <h3 style={{fontSize: '1.1rem', marginBottom: '5px'}}>{item.service_name}</h3>
                                    {item.price && <div style={{fontWeight: 900, marginBottom: '20px'}}>₹{item.price}</div>}
                                    <button onClick={() => addToCart(item)} className="btn-dark" style={{width: '100%', cursor: 'pointer'}}>ADD TO CART</button>
                                </div>
                            </div>
                         ))}
                    </div>
                </div>
            </div>

            <footer className="footer" id="contact">
                <div className="container">
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <div>
                             <div className="brand" style={{marginBottom: '20px'}}>{get_data.service_name}</div>
                             <p>{get_data.business_location_name}</p>
                             <p>{get_data.email}</p>
                        </div>
                        <div>
                             <h4 style={{marginBottom: '20px'}}>LINKS</h4>
                             <ul style={{listStyle: 'none', padding: 0, lineHeight: 2}}>
                                <li><a href="#">Home</a></li>
                                <li><a href="#services">Services</a></li>
                                <li><a href="#products">Store</a></li>
                             </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Twentieththeme;
